import {hasLocalStorage} from './local-storage'

// Fallback if local or session storage fail.
const createMemoryStorage = () => {
  let store: Record<string, string> = {}

  return {
    setItem(key: string, value: string) {
      store[key] = value
    },
    getItem(key: string) {
      return store[key] || null
    },
    removeItem(key: string) {
      delete store[key]
    },
    clear() {
      store = {}
    },
  }
}

export default (keepSignedIn = false) => {
  const memoryStorage = createMemoryStorage()
  return {
    setItem(key: string, value: string) {
      if (hasLocalStorage) {
        const storage = keepSignedIn ? global.localStorage : global.sessionStorage
        try {
          storage.setItem(key, value)
        } catch (error) {
          memoryStorage.setItem(key, value)
        }
      } else {
        memoryStorage.setItem(key, value)
      }
    },
    getItem(key: string) {
      if (memoryStorage.getItem(key)) {
        return memoryStorage.getItem(key)
      }

      if (hasLocalStorage) {
        return global.sessionStorage.getItem(key) || global.localStorage.getItem(key)
      }

      return null
    },
    removeItem(key: string) {
      if (hasLocalStorage) {
        global.sessionStorage.removeItem(key)
        global.localStorage.removeItem(key)
      }

      memoryStorage.removeItem(key)
    },
    clear() {
      if (hasLocalStorage) {
        global.sessionStorage.clear()
        global.localStorage.clear()
      }

      memoryStorage.clear()
    },
  }
}
